ko.bindingHandlers.flot = {
	update: function(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
		var $element = $(element),
			value = ko.utils.unwrapObservable(valueAccessor()) || {};

		if(value.data || value.options)
			$.plot($element, value.data || [], value.options || {});
	}
};
